



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getAllApprovedPurchasesWithCreatorAndApprover
// GETALLAPPROVEDPURCHASESWITHCREATORANDAPPROVER


const GETALLAPPROVEDPURCHASESWITHCREATORANDAPPROVER= createAsyncThunk(
  "getAllApprovedPurchasesWithCreatorAndApprover/getAllApprovedPurchasesWithCreatorAndApprover",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllApprovedPurchasesWithCreatorAndApproverSlice = createSlice({
  name: "getAllApprovedPurchasesWithCreatorAndApproverSlice",
  initialState: {
    getAllApprovedPurchasesWithCreatorAndApprover: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllApprovedPurchasesWithCreatorAndApprover: (state) => {
        state.getAllApprovedPurchasesWithCreatorAndApprover.loading = false
        state.getAllApprovedPurchasesWithCreatorAndApprover.error = false
        state.getAllApprovedPurchasesWithCreatorAndApprover.data = []
        state.getAllApprovedPurchasesWithCreatorAndApprover.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLAPPROVEDPURCHASESWITHCREATORANDAPPROVER.fulfilled, (state, action) => {
      state.getAllApprovedPurchasesWithCreatorAndApprover = {
        ...state.getAllApprovedPurchasesWithCreatorAndApprover,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLAPPROVEDPURCHASESWITHCREATORANDAPPROVER.pending, (state, action) => {
      state.getAllApprovedPurchasesWithCreatorAndApprover = {
        ...state.getAllApprovedPurchasesWithCreatorAndApprover,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLAPPROVEDPURCHASESWITHCREATORANDAPPROVER.rejected, (state, action) => {
      state.getAllApprovedPurchasesWithCreatorAndApprover = {
        ...state.getAllApprovedPurchasesWithCreatorAndApprover,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllApprovedPurchasesWithCreatorAndApproverAction = {
    GETALLAPPROVEDPURCHASESWITHCREATORANDAPPROVER,
};

export { getAllApprovedPurchasesWithCreatorAndApproverAction };
export default getAllApprovedPurchasesWithCreatorAndApproverSlice.reducer;
export const {setInitialStateOfgetAllApprovedPurchasesWithCreatorAndApprover} = getAllApprovedPurchasesWithCreatorAndApproverSlice.actions
